import gql from 'graphql-tag';

export default gql`
  query ordersPrint($orderPdfUrls: [String]) {
    ordersPrint(orderPdfUrls: $orderPdfUrls)
  }
`;
